import "./styles.css";
import { Box, Typography } from "@mui/material";

const NeedAssessComponent = ({ icon, heading, content }) => {
  return (
    <Box>
      <Box className="need-container">
        <Box className="icon-container">{icon}</Box>
        <Box>
          <Typography className="need-assess-heading">{heading}</Typography>
          <Typography className="need-assess-content">{content}</Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default NeedAssessComponent;
